import { listToMapByProperty } from '../../../utility/converters';

export function updateAllProjects(store, records) {
  const oldProjects = store.get('allProjects') || {};
  const newProjects = listToMapByProperty(records, 'hid');
  store.set('allProjects', { ...newProjects, ...oldProjects });
}
